import { hexToNumber } from '../../utils/encoding/fromHex.js';
export async function getTxpoolStatus(client) {
    const { pending, queued } = await client.request({
        method: 'txpool_status',
    });
    return {
        pending: hexToNumber(pending),
        queued: hexToNumber(queued),
    };
}
//# sourceMappingURL=getTxpoolStatus.js.map